var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as go from '../../../../libs/gojs/release/go';
import * as _ from 'lodash';
import { VariableDefinition } from '@flexem/fc-gui';
import { DiagramConsts } from '../diagram-consts';
import { ConditionalEnableNodeElement } from './base/conditional-enable-node-element';
import { GraphService } from '../../../../shared/gallery/graph.service';
import { AccessPermission } from '../../../../shared/fbox/fbox/access-permission';
import { FontStyleHelper } from '../../shared/helpers/font-style-helper';
var CharacterElement = /** @class */ (function (_super) {
    __extends(CharacterElement, _super);
    function CharacterElement(injector) {
        var _this = _super.call(this, injector) || this;
        _this.graphService = injector.get(GraphService);
        return _this;
    }
    CharacterElement.prototype.compile = function (model, data, svg) {
        model['version'] = 4;
        model['angle'] = data.angle;
        if (data.readVariableVersion) {
            var readVariable = _.find(DiagramConsts.compilerUsedVariables, function (v) { return v.variableName === data.readVariableName; });
            if (null != readVariable) {
                if (data.readVariableVersion) {
                    model['readVariable'] = { name: data.readVariableName, variableVersion: data.readVariableVersion };
                }
            }
        }
        else {
            var readVariable = _.find(DiagramConsts.compilerUsedVariables, function (v) { return v.dataSourceCode === data.readDataSourceCode
                && v.fBoxVariableName === data.readVariableName &&
                (!data.readVariableGroupName || (v.fBoxGroupName === data.readVariableGroupName)); });
            if (null != readVariable) {
                model['readVariable'] = new VariableDefinition(readVariable.fBoxVariableName, readVariable.fBoxGroupName, readVariable.dataSourceCode);
            }
        }
        if (data.accessPermission === AccessPermission.ReadWrite) {
            if (data.isSameVariable) {
                model['writeVariable'] = model['readVariable'];
            }
            else {
                if (data.writeVariableVersion) {
                    var writeVariable = _.find(DiagramConsts.compilerUsedVariables, function (v) { return v.variableName === data.writeVariableName; });
                    if (null != writeVariable) {
                        model['writeVariable'] = { name: data.writeVariableName, variableVersion: data.writeVariableVersion };
                    }
                }
                else {
                    var writeVariable = _.find(DiagramConsts.compilerUsedVariables, function (v) { return v.dataSourceCode === data.writeDataSourceCode
                        && v.fBoxVariableName === data.writeVariableName &&
                        (!data.writeVariableGroupName || (v.fBoxGroupName === data.writeVariableGroupName)); });
                    if (null != writeVariable) {
                        model['writeVariable'] = new VariableDefinition(writeVariable.fBoxVariableName, writeVariable.fBoxGroupName, writeVariable.dataSourceCode);
                    }
                }
            }
        }
        model['isPassword'] = data.isPassword;
        model['isSameVariable'] = data.isSameVariable;
        model['accessPermission'] = data.accessPermission;
        model['useGraph'] = data.useGraph;
        model['graphSetting'] = data.graphSetting;
        model['useSecurity'] = data.useSecurity;
        model['isRecordOperation'] = data.isRecordOperation;
        if (data.isRecordOperation) {
            model['operationDescription'] = data.operationDescription;
        }
        model['enablePassword'] = data.enablePassword;
        model['size'] = this.sizeService.parse(data.size);
        model['label'] = data.label;
        model['charCount'] = data.charCount;
        if (this.hasDynamicSetting(data)) {
            model['dynamicSetting'] = data.dynamicSetting;
            model['location'] = go.Point.parse(data.loc);
            model['fixedPositionType'] = data.fixedPositionType;
        }
        model['showVariableText'] = data.showVariableText;
        model['variableText'] = data.variableText;
        svg.children().remove();
    };
    CharacterElement.prototype.getPaletteTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', { width: 50, height: 90, locationSpot: go.Spot.Center }, $(go.Picture, { margin: 10, source: '/assets/common/images/configure/elements/character-display.png' }), $(go.TextBlock, {
            alignment: go.Spot.Center,
            text: this.l(this.getCategoryKey()),
            editable: false
        }));
    };
    CharacterElement.prototype.getDiagramTemplate = function () {
        var _this = this;
        var $ = go.GraphObject.make;
        return $(go.Node, 'Auto', {
            rotatable: true,
            locationObjectName: 'SHAPE', locationSpot: go.Spot.TopLeft, resizable: true,
            selectionAdornmentTemplate: $(go.Adornment, 'Spot', $(go.Panel, go.Panel.Auto, $(go.Shape, { fill: null, stroke: 'dodgerblue', strokeWidth: 1 }, new go.Binding('stroke', 'locked', function (locked) { return locked ? '#f65177' : 'dodgerblue'; })), $(go.Placeholder)))
        }, new go.Binding('locationSpot', '', function (data) {
            return _this.getFixedPositionType(data);
        }), new go.Binding('angle').makeTwoWay(), new go.Binding('movable', 'locked', function (locked) { return !locked; }), new go.Binding('resizable', 'locked', function (locked) { return !locked; }), new go.Binding('deletable', 'locked', function (locked) { return !locked; }), new go.Binding('rotatable', 'locked', function (locked) { return !locked; }), new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify), new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), new go.Binding('zOrder'), $(go.Shape, { fill: 'transparent', stroke: 'gray', strokeWidth: 0.5, strokeDashArray: [4, 4] }, new go.Binding('visible', 'useGraph', function (useGraph) { return !useGraph; })), $(go.Panel, 'Horizontal', $(go.Panel, 'Auto', $(go.TextBlock, {
            alignment: go.Spot.Center,
            editable: false,
            verticalAlignment: go.Spot.Center
        }, new go.Binding('margin', '', function (data) {
            var margin = 0;
            if (data.showVariableText) {
                margin = 8;
            }
            return margin;
        }), new go.Binding('desiredSize', '', function (data) { return _this.calcVariableTextSize(data); }), new go.Binding('visible', 'showVariableText'), new go.Binding('text', 'variableText', function (label) { return label.content + ':'; }), new go.Binding('font', 'variableText', function (label) {
            return _this.setEditTextFontFamilyMustBeYaHei(FontStyleHelper.buildFontStyle(label.font.isBold, label.font.isItalic, FontStyleHelper.addPx(label.font.fontSize)));
        }), new go.Binding('isUnderline', 'variableText', function (label) { return label.font.isUnderline; }), new go.Binding('stroke', 'variableText', function (label) { return label.font.color; }), new go.Binding('textAlign', 'variableText', function (label) { return label.font.textAlign; }))), $(go.Panel, 'Auto', $(go.Picture, { name: 'IMAGE' }, { sourceCrossOrigin: function (pict) { return 'anonymous'; } }, new go.Binding('desiredSize', '', function (data) { return _this.calcGraphSize(data); }), new go.Binding('source', 'graphSetting', function (setting, __) { return _this.graphService.getCustomStyleGraphUrl(setting); }), new go.Binding('visible', 'useGraph')), $(go.TextBlock, {
            alignment: go.Spot.Center,
            minSize: new go.Size(40, 10),
            margin: 9,
            editable: false,
            verticalAlignment: go.Spot.Center,
            wrap: go.TextBlock.WrapDesiredSize
        }, new go.Binding('desiredSize', '', function (data) { return _this.calcGraphSize(data); }), new go.Binding('font', 'label', function (label) { return _this.setEditTextFontFamilyMustBeYaHei(label.font.fontStyle); }), new go.Binding('isUnderline', 'label', function (label) { return label.font.isUnderline; }), new go.Binding('stroke', 'label', function (label) { return label.font.color; }), new go.Binding('textAlign', 'label', function (label) { return label.font.textAlign; }), new go.Binding('text', 'isPassword', function (a, b) { return _this.getDefaultNumericalDisplayText(b.panel.panel.panel.data); }), new go.Binding('text', 'readVariableName', function (a, b) { return _this.getDefaultNumericalDisplayText(b.panel.panel.panel.data); })))));
    };
    CharacterElement.prototype.setEditTextFontFamilyMustBeYaHei = function (font) {
        var fontArray = font.split('px');
        fontArray.pop();
        fontArray.push(' Microsoft YaHei,msyh');
        return fontArray.join('px');
    };
    CharacterElement.prototype.getCategoryKey = function () {
        return DiagramConsts.elements.characterKey;
    };
    CharacterElement.prototype.calcVariableTextSize = function (data) {
        var size = go.Size.parse(data.size);
        if (data.showVariableText) {
            size.width = size.width * 7 / 11 - 16;
        }
        else {
            size.width = 0;
        }
        return size;
    };
    CharacterElement.prototype.calcGraphSize = function (data) {
        var size = go.Size.parse(data.size);
        if (data.showVariableText) {
            size.width = size.width * 4 / 11;
        }
        return size;
    };
    CharacterElement.prototype.getDefaultNumericalDisplayText = function (nodeData) {
        if (nodeData.readVariableName && nodeData.readVariableName.length > 0) {
            if (nodeData.isPassword) {
                return '*****';
            }
            else {
                return 'Abc';
            }
        }
        return '';
    };
    CharacterElement.prototype.buildDefaultBinaryText = function (integerDigits) {
        return '1'.repeat(integerDigits);
    };
    CharacterElement.prototype.buildDefaultHexText = function (integerDigits) {
        return 'F'.repeat(integerDigits);
    };
    CharacterElement.prototype.buildDefaultNumericalText = function (integerDigits, fractionDigits) {
        var displayText = '';
        var index = 1;
        if (integerDigits > 0) {
            var displayIntegerText = '';
            for (; index <= integerDigits; index++) {
                displayIntegerText += index % 10;
            }
            displayText += displayIntegerText;
        }
        if (fractionDigits > 0) {
            var displayDecimalText = '';
            for (; index <= integerDigits + fractionDigits; index++) {
                displayDecimalText += index % 10;
            }
            displayText += (integerDigits > 0 ? '.' : '0.') + displayDecimalText;
        }
        return displayText;
    };
    return CharacterElement;
}(ConditionalEnableNodeElement));
export { CharacterElement };
